"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attendee = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Attendee = function Attendee() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.448 15.336l.378.377c.11.111.173.262.174.419v.707a.598.598 0 01-.174.419l-6.558 6.568a.6.6 0 01-.42.174h-.708a.6.6 0 01-.42-.174l-.378-.377a.598.598 0 01-.156-.67c.078-.19.116-.394.114-.6 0-.826-.672-1.496-1.5-1.496a1.545 1.545 0 00-.6.114.6.6 0 01-.648-.156l-.378-.377a.599.599 0 01-.174-.42v-.706c0-.157.063-.308.174-.42l6.558-6.544a.601.601 0 01.42-.174h.708a.6.6 0 01.42.15l.378.377c.188.169.25.437.156.671-.078.19-.116.394-.114.599 0 .826.672 1.497 1.5 1.497.206.002.41-.037.6-.114a.6.6 0 01.648.156zM16.8 17.988c0 .662.537 1.198 1.2 1.198a1.199 1.199 0 100-2.395c-.663 0-1.2.536-1.2 1.197z",
    clipRule: "evenodd",
    opacity: "0.72"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M9.624 8.75a4.376 4.376 0 10-4.377-4.375A4.357 4.357 0 009.624 8.75zM1.745 21a1.751 1.751 0 01-1.558-2.538l1.75-3.325a5.252 5.252 0 014.605-2.887h6.162c.907 0 1.78.233 2.544.656.207.114.233.393.066.56l-4.2 4.191-.004.004c-.388.391-.608.919-.61 1.47v.72c0 .175.023.348.066.514.075.29-.116.635-.415.635H1.745z"
  }));
};

exports.Attendee = Attendee;